import { useMutation } from "@tanstack/react-query";
import { ConfigureResource } from "@/api/generated-api";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { REQUEST_FORM_SCHEMA } from "../_components/request-section/request-form/constants";
import { ApiConfigure } from "@/api/configure";

export const useConfiguratorData = () => {
  const methods = useForm<ConfigureResource>({
    resolver: zodResolver(REQUEST_FORM_SCHEMA),
    defaultValues: {
      email: "",
      name: "",
      phone: "",
      message: "",
      files: [],
    },
    mode: "onSubmit",
    reValidateMode: "onChange",
  });

  const { mutate, isPending, isSuccess, reset } = useMutation({
    mutationFn: (data: ConfigureResource) => ApiConfigure.postConfigure(data),
    onSuccess: () => {
      methods.reset();
    },
    onError: error => {
      const { message } = error;

      methods.setError("root.serverError", {
        type: "server",
        message,
      });
    },
  });

  const onSubmit = methods.handleSubmit(data => {
    methods.clearErrors("root.serverError");

    mutate(data);
  });

  return { onSubmit, reset, methods, isPending, isSuccess };
};
